import React, {useEffect, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import CopierSortContainer from '../../../features/page/copyTrading/copier/CopierSortContainer'
import useQueryCopierList from '../../../hooks/api/copier/useQueryCopiersList'
import CopiersTable from '../../../features/page/copyTrading/copier/CopiersTable'
import WizPagination from '../../../components/pagination/WizPagination'
import Text from '../../../components/text/Text'
import Span from '../../../components/text/Span'

interface IProps {
    className?: string
}

const CopierPage: React.FC<IProps> = ({className}) => {
    const [exchange, setExchange] = useState('')
    const [sortBy, setSortBy] = useState('created_at')
    const [status, setStatus] = useState('running')
    const [currentPage, setCurrentPage] = useState(1)

    // 백엔드는 filter_status가 비었을 때만 '삭제 제외 전체'다.
    // 'all'을 그대로 보내면 running이 아닌 봇(=paused)만 걸러진다.
    const filterStatus = status === 'all' ? '' : status

    const {data, refetch} = useQueryCopierList(filterStatus, exchange, sortBy, currentPage)

    useEffect(() => {
        refetch()
    }, [sortBy, currentPage, exchange, status])

    useEffect(() => {
        const sortParams = new URLSearchParams(window.location.search).get('sort')
        const currentPageParams = new URLSearchParams(window.location.search).get('page')
        const exchangeParams = new URLSearchParams(window.location.search).get('exchange')
        const statusParams = new URLSearchParams(window.location.search).get('status')
        setSortBy(sortParams || 'created_at')
        setCurrentPage(Number(currentPageParams) || 1)
        setExchange(exchangeParams || '')
        setStatus(statusParams || 'running')
    }, [])

    const onChangeFunction = (e, type = 'sort' || 'page' || 'exchange' || 'status') => {
        if (type === 'sort') {
            setSortBy(e)
            setCurrentPage(1)
            window.history.pushState('', '', `?sort=${e}&page=1&exchange=${exchange}&status=${status}`)
        } else if (type === 'page') {
            setCurrentPage(e)
            window.history.pushState('', '', `?sort=${sortBy}&page=${e}&exchange=${exchange}&status=${status}`)
        } else if (type === 'exchange') {
            setExchange(e)
            setCurrentPage(1)
            window.history.pushState('', '', `?sort=${sortBy}&page=1&exchange=${e}&status=${status}`)
        } else if (type === 'status') {
            setStatus(e)
            setCurrentPage(1)
            window.history.pushState('', '', `?sort=${sortBy}&page=1&exchange=${exchange}&status=${e}`)
        }
    }

    return (
        <PageLayout title={'Copier'} className={className}>
            <CopierSortContainer
                sortBy={sortBy}
                onChangeSort={e => onChangeFunction(e, 'sort')}
                exchange={exchange}
                onChangeExchange={e => onChangeFunction(e, 'exchange')}
                status={status}
                onChangeStatus={e => onChangeFunction(e, 'status')}
            />
            <div className={'mt-[30px]'}>
                <Text className={'text-ti1'}>
                    <Span
                        className={`text-ti2 px-[7px] py-[3px] rounded-[3px] ${
                            status === 'running'
                                ? 'text-font_green bg-tag_green_light '
                                : status === 'paused'
                                ? 'text-font_red bg-tag_red_light'
                                : 'text-font02 bg-line03'
                        }`}>
                        {status === 'running' ? 'Running' : status === 'paused' ? 'Paused' : 'All'}
                    </Span>{' '}
                    Total Copier Count : {data?.pageInfo?.total_count}
                </Text>
            </div>
            <CopiersTable data={data?.data} className={'mt-[10px]'} />
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={e => onChangeFunction(e, 'page')}
            />
        </PageLayout>
    )
}

export default CopierPage
